/**
 * Detects when a newer version of the app has been published while this tab
 * was open. Old page files disappear on publish, so once a new version exists
 * the next navigation should be a full page load instead of an in-app switch.
 */
const CHECK_INTERVAL_MS = 5 * 60_000;
const ENTRY_RE = /\/assets\/index-[A-Za-z0-9_-]+\.js/;

let currentEntry: string | null = null;
let staleBuild = false;
let started = false;

export const extractEntryScript = (html: string): string | null =>
  html.match(ENTRY_RE)?.[0] ?? null;

export const isStaleBuild = () => staleBuild;

const readCurrentEntry = (): string | null => {
  for (const s of Array.from(document.scripts)) {
    const m = s.src && s.src.match(ENTRY_RE);
    if (m) return m[0];
  }
  return null;
};

const check = async () => {
  if (staleBuild || !currentEntry) return;
  try {
    const res = await fetch(`/?_v=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) return;
    const latest = extractEntryScript(await res.text());
    if (latest && latest !== currentEntry) staleBuild = true;
  } catch {
    // offline / transient — try again later
  }
};

export const startVersionWatcher = () => {
  if (started || typeof window === "undefined" || !import.meta.env.PROD) return;
  if (window.location.pathname.startsWith("/embed")) return;
  currentEntry = readCurrentEntry();
  if (!currentEntry) return;
  started = true;
  window.setInterval(check, CHECK_INTERVAL_MS);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") check();
  });
};
